export default {
      id: "arrow-diagnol-usage",
      viewBox: "0 0 22 22",
      url: __webpack_public_path__ + "sprite.svg#arrow-diagnol",
      toString: function () {
        return this.url;
      }
    }